module.exports = __webpack_public_path__ + "static/media/texto_3.8de42c0c.png";